import { render, staticRenderFns } from "./LinedTextarea.vue?vue&type=template&id=c6f5bb0a"
import script from "./LinedTextarea.vue?vue&type=script&lang=js"
export * from "./LinedTextarea.vue?vue&type=script&lang=js"
import style0 from "./LinedTextarea.vue?vue&type=style&index=0&id=c6f5bb0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports